module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-showcase"
  }, [_c('header-prop', {
    staticClass: "header-prop-showcase",
    attrs: {
      "title": "Define",
      "subtitle": "app"
    }
  }), _vm._v(" "), _c('div-columns', {
    staticClass: "div-content",
    attrs: {
      "column-num": "is-8",
      "div-style": {}
    }
  }, [_c('div', {
    staticClass: "column"
  }, [(_vm.$route.params.type.toLowerCase() === 'ios') ? _c('div', _vm._l((_vm.projects), function(project) {
    return _c('div', {
      key: project.name,
      staticStyle: {
        "margin-top": "2em",
        "margin-bottom": "2em"
      },
      attrs: {
        "align": "center"
      }
    }, [_c('h1', {
      staticStyle: {
        "margin-top": "2em",
        "margin-bottom": "0.5em"
      }
    }, [_vm._v(_vm._s(project.title))]), _vm._v(" "), (project.linkLabel && project.link) ? _c('h4', {
      staticStyle: {
        "margin-left": "0.5em",
        "margin-top": "0em",
        "margin-bottom": "1em"
      }
    }, [_c('a', {
      attrs: {
        "href": project.link
      }
    }, [_vm._v(_vm._s(project.linkLabel))])]) : (project.linkLabel && project.link === undefined) ? _c('h4', {
      staticStyle: {
        "margin-left": "0.5em",
        "margin-top": "0em",
        "margin-bottom": "1em"
      }
    }, [_vm._v(_vm._s(project.linkLabel))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "display": "inline-block",
        "font-size": "0"
      },
      attrs: {
        "align": "left"
      }
    }, _vm._l((project.images), function(info) {
      return _c('lightbox', {
        key: info.path,
        staticStyle: {
          "display": "inline-block",
          "width": "50%",
          "cursor": "pointer"
        },
        attrs: {
          "caption": project.title,
          "src": info.path,
          "album": 'test'
        }
      }, [_c('img', {
        staticStyle: {
          "display": "inline-block"
        },
        attrs: {
          "src": info.path,
          "data-pin-nopin": "true"
        }
      })])
    }))])
  })) : _c('div', [_c('span', [_vm._v("else")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2545ef8d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Showcase.vue
// module id = 807
// module chunks = 1